/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconIceCreamOff = createReactComponent("ice-cream-off", "IconIceCreamOff", [
  ["path", { d: "M12 21.5v-4.5", key: "svg-0" }],
  ["path", { d: "M8 8v9h8v-1m0 -4v-5a4 4 0 0 0 -7.277 -2.294", key: "svg-1" }],
  ["path", { d: "M8 10.5l1.74 -.76m2.79 -1.222l3.47 -1.518", key: "svg-2" }],
  ["path", { d: "M8 14.5l4.488 -1.964", key: "svg-3" }],
  ["path", { d: "M3 3l18 18", key: "svg-4" }]
]);

export { IconIceCreamOff as default };
//# sourceMappingURL=IconIceCreamOff.js.map
